import {defineStore} from 'pinia'
import Util from '@/utils/util';
import Axs from '@/utils/axs';
import { defineAsyncComponent,markRaw} from 'vue'

//const address = "127.0.0.1"
 const address = "https://www.jl-zhwl.com"
 const minIOAddress = "https://minio.jl-zhwl.com"
//   const address = "http://127.0.0.1:32081"
//   const minIOAddress = "http://127.0.0.1:9050"

 //const address = "https://www.nnyzb.top"
 //const minIOAddress = "https://minio.nnyzb.top"
//const address = "https://test.jl-zhwl.com"

function loadToken()
{
    let token = localStorage.getItem("token");
    let curtime =  (new Date()).getTime()/1000;
    let time = localStorage.getItem("tokenExpire");
    if(curtime - time >= 3600*24 )
    {
        localStorage.setItem("token","");
        return "";
    }
    return token;
}

let storeFunc = defineStore("info",{
    state:()=>{
        return {
           //业务数据  count:99
           logoutFlash:false,
           loginLoadding:false,
           token:loadToken(),
           smsWaittingSecond:0,
           defaultSvg:"<img style='width:90px;height:28px;' src='#'>",
           autoqrcode:"",
           reset_acc:"",
           reset_code:"",
           reset_sms:"",
           version:"0.0.0",
           catalogPages:{},//目录
           tempMenuObj:null,
           AccountTypeEnum:[
            {
                id: 0,
                label: "普通账号"
            },
            {
                id: 1,
                label: "手机号"
            },
            {
                id: 2,
                label: "邮箱"
            },
            {
                id: 3,
                label: "微信"
            },
            {
                id: 4,
                label: "QQ"
            },
            {
                id: 5,
                label: "新浪微博"
            },
        ],
        }
    },
    actions:{
        //方法
        // doSum()
        // {
        //     this.count++
        // }
        saveToken(value)
        {
            localStorage.setItem("token",value);
            let curtime =  (new Date()).getTime()/1000;
            localStorage.setItem("tokenExpire",curtime);
            this.token = value;
        },

        loadToken()
        {
            let token = localStorage.getItem("token");
            let curtime =  (new Date()).getTime() / 1000;
            let time = localStorage.getItem("tokenExpire");
            if(curtime - time >= 3600*24 )
            {
                localStorage.setItem("token","");
                this.token ="";
                return "";
            }
            this.token = token;
            return token;
        },

         getQrCode() {
           //  console.log("11111");
            let nanoid = localStorage.getItem("nanoid");
            if (Util.isEmpty(nanoid)) {
              nanoid = "\\0";
            } else {
              nanoid = "\\" + nanoid;
            }
            
            Axs.get(this.linkUrl + "api/qrcode" + nanoid, null, null, (req) => {
              // console.log("req",req)
              if (!Util.isEmpty(req.nanoid)) {
                localStorage.setItem("nanoid", req.nanoid);
              }
              this.defaultSvg =
                "<div style='display:inline-block;vertical-align:top;font-size:0;'>" +
                req.data.code +
                "</div>";
   
      
              this.autoqrcode = req.data.autoqrcode
            },null,null,true);
          },
          clear()
          {
            this.token =loadToken();
            this.smsWaittingSecond=0;
            this.defaultSvg="<img style='width:90px;height:28px;' src='#'>";
            this.autoqrcode="";
            this.reset_acc="";
            this.reset_code="";
            this.reset_sms="";
            this.loginLoadding=false
          },
            selectMainMenu(storeHome,mainMenu,router,params)
            {
                //  console.log("handleSelect event",event,p1);
                //  console.log("p1",p1);
                if(params == undefined)
                    params = {}
                storeHome.selectMainMenu = mainMenu
                let path = '/home/' + storeHome.selectMainMenu
                if(storeHome.selectMainMenu >= 100)
                {
                    router.push({path,query:params,
                        beforeEnter: (to, from, next) => {
                            console.log("beforeEnter???????????")
                        }
                    });//进入大厅
                    return true;
                }
                let mainMenuObj = storeHome.getSelectMainMenu()
                if(Util.isEmpty(mainMenuObj))
                    return false
                if(this.catalogPages[path] == undefined)
                {
                    this.catalogPages[path] = {
                        mainMenuObj:mainMenuObj,
                        curStore:null,
                        treeObj:{
                        store:[]
                    }
                }
                }
                this.tempMenuPath = path
               // console.log("??????????params=>",params)
                router.push({path,query:params,
                    beforeEnter: (to, from, next) => {
                            console.log("beforeEnter???????????")
                    }
                });//进入大厅
                return true;
            },
        catalogPageSearch(path,params,storeHome)
        {
            if(params == undefined || JSON.stringify(params) == "{}")
            {
                return false;
            }
            let functionName = params.functionName
    
            let searchs = {
                ...params
            }
            delete searchs.functionName
            


            let catalogPage = this.catalogPages[path];
            //console.log("catalogPage==>",catalogPage);
            if(catalogPage.treeObj)
            {
                console.log("catalogPage.treeObj.store==>",catalogPage.treeObj.store)
                 console.log("functionName==>",functionName)
                
                let storeObj = Util.getArrayDeepsObj(catalogPage.treeObj.store,'store.functionName',functionName)
       
                if(Util.isEmpty(storeObj))
                {
                    return false
                }
                let _store =  storeObj.store
                if(Util.isEmpty(_store))
                {
                    return false
                }
                if(_store.enable == 0)
                {
                    return false
                }
                if(_store.disabled)
                { 
                    return false
                }
                    // console.log("??????????============this.selectStore",storeObj)
                return this.selectStore(_store,catalogPage.curStore,storeHome,searchs);
            } 
            return false
        },
         selectStore(store,_curStore,storeHome,searchs)
         {
            //console.log("store????????",store)
           // console.log("_curStore????????",_curStore)
           //  console.log("storeHome????????",storeHome)
            if(store.enable != 1&& store.enable != "1")
                return false;

            if(Util.isEmpty(store.functionName))
                return false;
                //检查销毁的组件，重新创建
                for(let i = 0 ; i < _curStore.openedfunsViewArr.length;i++)
                {
                    let viewFuns = _curStore.openedfunsViewArr[i];
                    if(Util.isEmpty(viewFuns.store.functionName))
                        continue;
                    if(viewFuns.view == undefined || viewFuns.view.setup == undefined)
                    {
                        let functionComponent = defineAsyncComponent(() =>{
                                return import('@/home/' +  storeHome.getSelectMainMenuById(viewFuns.store.mainmenu).functionName + '/' + viewFuns.store.functionName + '/index.vue')
                            })
                        if(Util.isEmpty(functionComponent))
                        {
                            functionComponent = defineAsyncComponent(() =>{
                                return import('@/home/'  + viewFuns.store.functionName + '/index.vue')
                            }) 
                        }
                        viewFuns.view = markRaw(functionComponent);
                    }
                }

                //找到已打开的
                for(let i = 0 ; i < _curStore.openedfunsViewArr.length;i++)
                {
                    let viewFuns = _curStore.openedfunsViewArr[i];
                    if(viewFuns.store.id == store.id)
                    {
                    // console.log("viewFuns.view=>",viewFuns.view)
                        _curStore.funsLayout = viewFuns.view;
                        _curStore.funsLayoutTitle = viewFuns.store.name
                        _curStore.funsLayoutSearchs = searchs;
                        console.log("设置 _curStore.funsLayoutSearchs",searchs)
                        _curStore.tabSelected = viewFuns.store.id;
                       // console.log("找到已打开的")
                    // console.log("创建组件AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA1111111111",viewFuns.store)
                        return true;
                    }
                }
                

                let functionComponent = defineAsyncComponent(() =>{
                    return import('@/home/' + storeHome.getSelectMainMenu().functionName + '/' +store.functionName + '/index.vue')
                })
                if(Util.isEmpty(functionComponent))
                {
                    functionComponent = defineAsyncComponent(() =>{
                    return import('@/home/'  +store.functionName + '/index.vue')
                }) 
                }
                let viewFuns = {
                    view:markRaw(functionComponent),
                    store:store
                }
                //console.log("打开内容？？？？？？？？？？？？？？？？？")

                _curStore.openedfunsViewArr.push(viewFuns);
                
                _curStore.funsLayout = markRaw(functionComponent)
                _curStore.funsLayoutTitle = viewFuns.store.name;
                _curStore.funsLayoutSearchs = searchs;
                _curStore.tabSelected = viewFuns.store.id;

                // console.log("_curStore.openedfunsViewArr=>",_curStore.openedfunsViewArr)
                // console.log("_curStore.funsLayout=>", _curStore.funsLayout)
                // console.log("_curStore.funsLayoutTitle=>",_curStore.funsLayoutTitle)
                // console.log("_curStore.funsLayoutSearchs=>",_curStore.funsLayoutSearchs)
                // console.log("_curStore.tabSelected=>",_curStore.tabSelected)
           // console.log("创建组件AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA2222222222222",viewFuns.store)
           return true
        }
    },
    getters:{
        //计算属性，只读属性
        // linkAddress(){
        //     return address + ":"+ port
        // },
        // linkUrl(){
        //     return "http://" +  address + ":"+ port + "/"
        // },
        linkUrl(){
            return address + "/" 
        },
        // linkMinIOUrl()
        // {
        //     return "http://" +  address + ":"+ minIOport + "/"
        // }
        linkMinIOUrl()
        {
            return minIOAddress + "/" 
        }
    },
    persist: true
})

 //组合式写法 mixin混合写法
// let storeFunc = defineStore("user",()=>{
//     //组合式写法
//     let p = ref("xx");
//     return {
//         p
//     }
// })


export default storeFunc